// ============================================================
// Lobab School — Dual-API Configuration (Hybrid Architecture)
// ============================================================
// WhatsApp Automation → Local Server (session persistence, anti-ban)
// Video/Upload API   → Cloud Server (Render, 24/7 availability)
// ============================================================

// Local server: WhatsApp client with LocalAuth + Socket.io
export const WHATSAPP_BASE_URL = 'http://localhost:3001';

// Cloud server: Bunny.net video streaming, uploads, metadata
export const VIDEO_BASE_URL = 'https://lobab-backend.onrender.com';
